import { MODULE_ENTRY_WHOLE_MODULE_KEY } from './constants';
import { normalizePolicyMode, ProfileTemplateFieldMode } from './field-mode';
import type { GovernedModule } from './types';

type EntryWithPolicy = { id?: string; policy?: string };

function findEntryPolicy(
  module: GovernedModule,
  entryId: string,
): ProfileTemplateFieldMode | undefined {
  const config = (module.config ?? {}) as Record<string, unknown>;

  if (entryId === MODULE_ENTRY_WHOLE_MODULE_KEY) {
    const policy = config.policy;
    return typeof policy === 'string' ? normalizePolicyMode(policy) : undefined;
  }

  const findInList = (items: EntryWithPolicy[] | undefined) =>
    items?.find((item) => item.id === entryId)?.policy;

  let raw: string | undefined;
  switch (module.type) {
    case 'socials':
      raw = findInList(config.links as EntryWithPolicy[] | undefined);
      break;
    case 'contact_info':
      raw = findInList(config.items as EntryWithPolicy[] | undefined);
      break;
    case 'links':
      raw = findInList(config.items as EntryWithPolicy[] | undefined);
      break;
    case 'images': {
      const policy = config.policy;
      raw = typeof policy === 'string' ? policy : undefined;
      break;
    }
    case 'files':
    case 'team_members': {
      const policy = config.policy;
      raw = typeof policy === 'string' ? policy : undefined;
      break;
    }
    default:
      break;
  }

  return raw !== undefined ? normalizePolicyMode(raw) : undefined;
}

export function resolveEntryPolicy(
  module: GovernedModule,
  entryId: string,
): ProfileTemplateFieldMode {
  const explicit = findEntryPolicy(module, entryId);
  if (explicit !== undefined) {
    return explicit;
  }
  return ProfileTemplateFieldMode.FREE;
}

export function isEntryLocked(
  module: GovernedModule,
  entryId: string,
): boolean {
  return (
    resolveEntryPolicy(module, entryId) === ProfileTemplateFieldMode.LOCKED
  );
}
